<div class="card">
    <div class="card-body">
        <div class="widget-container">
            <div class="heading">
                {{"AI Automation Hub" | translate}}
            </div>

            <!-- Configuration Section (Hide when running) -->
            <div class="app-inputs" *ngIf="!isRunning && automationResults.length === 0">
                <div class="app-input-field">
                    <label>{{"App Package" | translate}}</label>
                    <input type="text" [(ngModel)]="appPackage" placeholder="com.example.app">
                </div>
                <div class="app-input-field">
                    <label>{{"App Activity" | translate}}</label>
                    <input type="text" [(ngModel)]="appActivity" placeholder=".MainActivity">
                </div>
            </div>

            <!-- Upload Section (Hide when running) -->
            <div class="mode-section" *ngIf="!isRunning && automationResults.length === 0">
                <div class="section-title">
                    {{"Requirement Document" | translate}}
                </div>
                <div class="upload-card" (click)="fileInput.click()">
                    <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)">
                    <div class="upload-icon">
                        <i class="fa" [class.fa-file-text-o]="!selectedFile"
                            [class.fa-check-square-o]="selectedFile"></i>
                    </div>
                    <p class="upload-text" *ngIf="!selectedFile">{{"Drop requirements here or click to browse" |
                        translate}}</p>
                    <p class="upload-text" *ngIf="selectedFile" style="color: #28a745; font-weight: 700;">
                        {{selectedFile.name}}</p>
                </div>
            </div>

            <!-- Execution Status/Trigger -->
            <div class="action-footer" style="margin-top: 20px;" *ngIf="isRunning || automationResults.length === 0">
                <!-- Start Button (Only if not running and no current results) -->
                <button *ngIf="!isRunning && automationResults.length === 0" class="run-btn" (click)="runAutomation()"
                    [disabled]="!selectedFile || !appPackage || !appActivity">
                    <i class="fa fa-play"></i>&nbsp;
                    {{"Run AI Automation" | translate}}
                </button>

                <!-- Running Status -->
                <div *ngIf="isRunning" class="status-indicator"
                    style="display: flex; align-items: center; gap: 15px; width: 100%;">
                    <i class="fa fa-circle-o-notch fa-spin" style="color: var(--bunting-blue); font-size: 20px;"></i>
                    <span
                        style="font-weight: 800; color: var(--bunting-blue); font-size: 11px; text-transform: uppercase; letter-spacing: 1px;">
                        {{"Automation in Progress..." | translate}}
                    </span>
                    <span style="margin-left: auto; font-size: 10px; opacity: 0.7;">SESSION: {{sessionId}}</span>
                </div>
            </div>

            <!-- Results Section (Visible as soon as actions start coming in) -->
            <div class="results-container animate-fade" *ngIf="isRunning || automationResults.length > 0">
                <div class="section-title"
                    style="color: var(--bunting-blue); border-bottom: 1px solid #eee; padding-bottom: 8px;">
                    <i class="fa" [class.fa-check-circle]="!isRunning" [class.fa-terminal]="isRunning"></i>&nbsp;
                    {{ (isRunning ? "Live Action Stream" : "Automation Summary") | translate }}
                    <span *ngIf="!isRunning" style="margin-left: auto; font-size: 10px; opacity: 0.7;">SESSION:
                        {{sessionId}}</span>
                </div>

                <div class="results-table-wrapper">
                    <table class="results-table">
                        <thead>
                            <tr>
                                <th style="width: 40px;">#</th>
                                <th style="width: 100px;">Action</th>
                                <th style="width: 120px;">Locator Type</th>
                                <th>Locator</th>
                                <th>Test Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="automationResults.length === 0 && isRunning">
                                <td colspan="5" style="text-align: center; padding: 40px; border-bottom: none;">
                                    <div class="shimmer-placeholder">
                                        <i class="fa fa-cogs" style="font-size: 24px; margin-bottom: 15px; color: var(--bunting-blue);"></i><br>
                                        <span style="font-weight: 700; color: #666; font-size: 12px; text-transform: uppercase;">Awaiting Live Stream...</span>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngFor="let result of automationResults; let i = index">
                                <td style="font-weight: 700; color: #999;">{{ i + 1 }}</td>
                                <td><span class="action-badge">{{ result.Action }}</span></td>
                                <td style="font-family: monospace; color: #666;">{{ result['Locator Type'] }}</td>
                                <td class="locator-cell">{{ result.Locator }}</td>
                                <td style="color: var(--bunting-blue); font-weight: 600;">{{ result['Test Data'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="action-footer" *ngIf="!isRunning">
                    <button class="run-btn" (click)="downloadScript()" [disabled]="isDownloading"
                        style="background: #fff; color: #28a745; border: 1px solid #28a745;">
                        <i class="fa" [class.fa-download]="!isDownloading" [class.fa-spinner]="isDownloading" [class.fa-spin]="isDownloading"></i>&nbsp;{{"Download Script" | translate}}
                    </button>
                    &nbsp;
                    <button class="run-btn" (click)="runAutomation()"
                        style="background: #fff; color: var(--bunting-blue); border: 1px solid var(--bunting-blue);">
                        <i class="fa fa-refresh"></i>&nbsp;{{"Run Again" | translate}}
                    </button>
                    &nbsp;
                    <button class="run-btn" (click)="setMode('document')"
                        style="background: #fff; color: #666; border: 1px solid #ccc;">
                        <i class="fa fa-plus"></i>&nbsp;{{"New Automation" | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>